module.exports = __webpack_public_path__ + "img/1 (78).8b08622c.png";